import React from 'react';
import activate from '../../assets/images/logos/activate.png';
import fepch from '../../assets/images/logos/fepch.png';
import pnud from '../../assets/images/logos/pnud.png';
import usfx3 from '../../assets/images/logos/usfx3.png';
import warmilab from '../../assets/images/logos/warmilab.png';


const partners = [
  { href: 'https://activatebolivia.org/', src: activate, alt: 'Activate' },
  { href: 'https://www.solydesaceleradora.org/', src: 'https://www.solydesaceleradora.org/wp-content/themes/aceleradora-solydes/assets/img/logo-header.jpg', alt: 'Solydes' },
  { href: 'https://www.usfx.bo/', src: usfx3, alt: 'USFX' },
  { href: 'https://www.facebook.com/ActivateSucreBolivia', src: warmilab, alt: 'Warmilab' },
  { href: 'https://www.facebook.com/Federacion-de-Empresarios-Privados-de-Chuquisaca-FEPCH-101234058189721/', src: fepch, alt: 'FEPCH' },
  { href: 'https://www.undp.org/es/', src: pnud, alt: 'PNUD' },
];

export default function Company(){

    return(
    
      <div  className="bg-fondo flex flex-col items-center w-full p-8 md:p-12" >
        <p className="text-primary text-sm font-bold uppercase tracking-widest">Alianzas</p>
        <h1 className="text-white text-3xl md:text-4xl text-center leading-relaxed font-bold mt-2">Apoyado por</h1>
        <div className="flex flex-row flex-wrap p-4 md:p-8 justify-center items-center w-full landing-wrap">
          {partners.map((partner) => (
            <a
              key={partner.alt}
              href={partner.href}
              target="_blank"
              rel="noopener noreferrer"
              className="m-3 bg-white rounded-xl p-4 flex items-center justify-center hover:shadow-lg transition duration-300"
            >
              <img src={partner.src} alt={partner.alt} className="partner-logo"/>
            </a>
          ))}
        </div>
      </div>
    
    );
};
